import { defineMessages } from "react-intl";

export default defineMessages({
  pay: {
    id: "stripePayWithCreditCard.pay",
    defaultMessage: "Pay {amount}",
  },
  setupErrorTitle: {
    id: "stripePayWithCreditCard.setupErrorTitle",
    defaultMessage: "Payment setup error",
  },
});
